export const BLOCKS_APP_DEF_ID = 'e9efdbf8-da07-47c2-8791-03b65458bb89';
export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const BOOKINGS_SECTION_ID = 'bookings_list';
export const PRICING_PLANS_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const SINGLE_PLAN_HELP_ARTICLE_ID = '63f37cb0-aaff-4d10-868b-5da5a88db58a';

export const DEFAULT_RIBBON_TEXT = 'Best Value';
